export function parseTPlot(blocks) {
  const betSurfaceAreaPlot = {};
  for (let block of blocks) {
    let submatrix = block['t-Plot'];
    if (!submatrix) continue;

    betSurfaceAreaPlot.meta = { kind: submatrix[1][0] };

    let headers = [];
    for (let row of submatrix) {
      if (row[0] && row[1]) {
        headers = row;
        break;
      }
    }

    betSurfaceAreaPlot.variables = {
      x: {
        data: [],
        units: headers[0].replace(/(.*) \((.*)\).*/, '$1'),
        label: headers[0].replace(/(.*) \((.*)\).*/, '$2'),
      },
      y: {
        data: [],
        units: headers[1].replace(/(.*) \((.*)\).*/, '$1'),
        label: headers[1].replace(/(.*) \((.*)\).*/, '$2'),
      },
    };

    for (let row of submatrix) {
      if (!isNaN(row[0]) && !isNaN(row[1])) {
        betSurfaceAreaPlot.variables.x.data.push(Number(row[0]));
        betSurfaceAreaPlot.variables.y.data.push(Number(row[1]));
      }
    }
    for (let row of submatrix) {
      if (!isNaN(row[2]) && !isNaN(row[3])) {
        betSurfaceAreaPlot.variables.x.data.push(Number(row[2]));
        betSurfaceAreaPlot.variables.y.data.push(Number(row[3]));
      }
    }
  }
  return betSurfaceAreaPlot;
}
